import { render, staticRenderFns } from "./RechargeDetail.vue?vue&type=template&id=06a4c7f7"
import script from "./RechargeDetail.vue?vue&type=script&lang=js"
export * from "./RechargeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports